import { scrollPageTo } from '../utils';

export default class Footer {
    static init(e) {
        const footer = e.detail.element.querySelector('[data-footer]');
        new Footer(footer);
    }

    constructor(footer) {
        if(!footer) {
            return;
        }

        this.footer = footer;
        this.scrollToTopButton = this.footer.querySelector('[data-scroll-to-top]');
        this.scrollToTopButton.addEventListener('click', () => {
            scrollPageTo(0, 1500, 0);
        });

    }
}
